var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('number-flow',_vm._b({ref:"el",staticClass:"cs-animated-number"},'number-flow',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }